import React, { useEffect, useRef, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BlockUi from '@availity/block-ui';
import {Circles} from "react-loader-spinner";
import { Button } from "@progress/kendo-react-buttons";
import InvoiceBidTable from "./InvoiceBidTable";
import { Input } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import {
  validateInvoiceInputs,
  submitChargesService,
  foInvoiceSubmitService,
  saveQuotation,
  createQuotation,
  percentageChecker,
  setPassThroughFeeCodeForInvoice,
  filterCurrencyWithVendorId,
  getDefaultCurrencyAsUSD,
  getAllQuotation,
  helperFunc,
  calculateTotalCharges,
  submitInvoiceInputs,
  submitChargesMethod,
  foSubmitInvoiceMethod,
  validateInvoiceFieldInputs,
  invoiceBidTableInputValidation,
  validateBidFieldInputs,
  foCancel,
  getThresholdValue,
  getWeightThreshold,
} from "./InvoiceBidDetailsServices";
import dayjs from "dayjs";

import "./InvoiceBidDetails.scss";
import { process } from "@progress/kendo-data-query";
import InvoiceBidCalculation from "./InvoiceBidCalculation";
import GatewayGet, { GatewayPost } from "../common/restService/GatewayGet";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { string } from "prop-types";
import { windowStage } from "@progress/kendo-react-dialogs/dist/npm/StageEnum";
import backBtn from "../images/back-button.png";

function InvoiceBidDetails({ props }) {
  const {
    currentComponent,
    tor_id, //Fo number
    ReqPickupDate,
    ReqDeliveryDate,
    docStatus, //request status
    vendor_id,
    invoiceInputs,
    TransportationValue, // A- air, M- road, R- rail, S-ocean
    onBidSaved,
    isEditClicked,
    onEditingFinished,
    tor_Type,
    isCreaedUserDifferentFromLoggedInUserAtStatus10,
    isNewRequest,
    invoiceDetailInputsOnSubmit,
    saveInvoiceDetailInputsOnSubmit,
    rfq_no = "",
    hideQuotation,
    quotationNum = "",
    rfq_multibid_currency = "",
    buttonType = "",
    timeFromZone = "",
    timeToZone = "",
    userRole = ""
  } = props;

  const [foSaccCurr, setfoSaccCurr] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [currencySelected, setCurrencySelected] = useState({
    currCode: "Select Currency",
  });
  const [childScacList, setChildScacList] = useState([]);
  const [childScacSelected, setChildScacSelected] = useState({
    childScac: "Select SCAC",
  });

  const [feeCodeData, setFeeCodeData] = useState([]);
  const [feeCodeDataForInvoice, setFeeCodeDataForInvoice] = useState([]);

  const [unitType, setUnitType] = useState([]);

  const currencyDropdownDisabled = useRef(false);

  const [invoiceBidInputs, setInvoiceBidInputs] = useState({
    hawbNumber: "",
    proNumber: "",
    actualShipmentPickupDate: "",
    actualShipmentDeliveryDate: "",
  });



  const [tableDataBid, setTableDataBid] = useState(null);
  const [tableDataInvoice, setTableDataInvoice] = useState(null);

  const [dataState, setDataState] = useState({
    skip: 0,
    take: 10,
  });
  const [dataStateInvoice, setDataStateInvoice] = useState({
    skip: 0,
    take: 10,
  });
  const [result, setResult] = useState(process([], dataState));
  const [resultInvoice, setResultInvoice] = useState(process([], dataState));

  const [totalCharges, setTotalCharges] = useState({
    totalContractedCharges: 0,
    totalNonContractedCharges: 0,
    totalQuotationCharges: 0,
  });

  const [totalChargesInvoice, setTotalChargesInvoice] = useState({
    totalContractedCharges: 0,
    totalNonContractedCharges: 0,
    totalQuotationCharges: 0,
  });

  const status = useRef(null);
  const isSubmitDisabled = useRef(false);
  const [blocking, setBlocking] = useState(true);

  const [visibleDialog, setVisibleDialog] = useState(false);
  const [hawbProValidation, setHawbProValidation] = useState(false);
  const dialogItems = useRef({
    dialogTitle: "",
    dialogContent: "",
    button1Content: "",
    button2Content: "",
    dialogFor: "",
  });
  const [submitInvoices, setSubmitInvoices] = useState(false);
  const [isAddFeeCodeClicked, setIsAddFeeCodeClicked] = useState(false);
  const [tempDisableSaveBtnBid, setTempDisableSaveBtnBid] = useState(false);

  useEffect(() => {
    async function loadDdandTableData() {
      setBlocking(true);

      let _props1 = helperFunc("F4_SCAC_CURR", "");
      const response1 = await GatewayGet(_props1, _props1.input);
      setfoSaccCurr(response1);
      setCurrencyList(filterCurrencyWithVendorId(response1, vendor_id));
      // Setting USA as default
      setCurrencySelected(
        getDefaultCurrencyAsUSD(
          response1,
          vendor_id,
          docStatus,
          rfq_multibid_currency
        )
      );

      let _props2 = helperFunc("F4_FEE_CODE_CHARGE_BASIS", "");
      let response2 = await GatewayGet(_props2, _props2.input);
      for (let i = 0; i < response2.length; i++) {
        response2[i].text =
          response2[i].feeCode + " (" + response2[i].description + ")";
      }
      setFeeCodeData(response2);
      const feeCodePassThrough = setPassThroughFeeCodeForInvoice(
        currentComponent,
        TransportationValue,
        response2,
        tor_Type
      );

      setFeeCodeDataForInvoice(feeCodePassThrough);

      let _props3 = helperFunc("F4_UNIT_TYPES", "");
      const response3 = await GatewayGet(_props3, _props3.input);
      setUnitType(response3);

      if (
        docStatus !== "" &&
        docStatus !== null &&
        (docStatus !== 35 || buttonType === "copy Quotation")
      ) {
        status.current = JSON.parse(docStatus);
        const allQuotations = await getAllQuotation(
          status,
          currentComponent,
          tor_id,
          tor_Type,
          rfq_no,
          quotationNum
        );
        populateDataToTable(allQuotations);
        rePopulateInvoiceBidInputs(allQuotations, "first time api call");

        if (typeof allQuotations.searchRes !== "undefined") {
          if (allQuotations.searchRes.length > 0 && docStatus === "10") {
            // method in intelShipRequest.jsx to enable submit button
            onBidSaved();
          }
        }
      } else if (docStatus === 35) {
        status.current = JSON.parse(docStatus);
        populateDataToTable({ searchRes: [] });
        setInvoiceBidInputs({
          ...invoiceBidInputs,
          actualShipmentPickupDate: new Date(ReqPickupDate),
          actualShipmentDeliveryDate: new Date(ReqDeliveryDate),
        });
      }

      setBlocking(false);

      autoPopulateInvoiceInputs();
    }
    loadDdandTableData();
  }, []);

  useEffect(() => {
    setTotalCharges(calculateTotalCharges(result.data));
    setTotalChargesInvoice(calculateTotalCharges(resultInvoice.data));
  }, [result, resultInvoice]);

  useEffect(() => {
    if (currentComponent === "invoice") {
      // child SCAC dropdown to be filled with filter item from selected current currency

      if (
        foSaccCurr.length !== 0 &&
        currencySelected["currCode"] !== ""
      ) {
        let _childSCACList = foSaccCurr.filter(
          (list) => list.currCode === currencySelected["currCode"]
        );

        // filter wrt vendor id
        _childSCACList = _childSCACList.filter(
          (list) => list.vendId === vendor_id
        );

        // filtering the duplicates if present
        _childSCACList = _childSCACList.filter(
          (list, index, arr) =>
            index === arr.findIndex((l) => l.childScac === list.childScac)
        );
        setChildScacList(_childSCACList);

        // If child scac data is coming from api for status 71 to display
        if (_childSCACList.length) {
          setChildScacSelected(
            invoiceInputs["childSCAC"] !== null
              ? _childSCACList.find(
                  (childScac) =>
                    invoiceInputs["childSCAC"] === childScac["childScac"]
                )
              : { childScac: "Select SCAC" }
          );
        }
      }
    }
  }, [currencySelected]);

  useEffect(() => {
    
    async function run() {
      if (submitInvoices === true && status.current === 70) {
        let response1 = await submitInvoiceInputs(
          invoiceBidInputs,
          childScacSelected,
          tor_id,
          tor_Type
        );

        // 1st api call
        if (response1["STATUS"] != null) {
          if (response1["STATUS"] === "SUCCESS") {
            toast.success("HAWB/PRO Number Updated Successfully");
            setVisibleDialog(false);
            // 2nd api call

            let response2 = await submitChargesMethod(
              tor_id,
              currencySelected,
              totalChargesInvoice
            );
            if (response2["status"] != null) {
              if (response2["status"] === "SUCCESS") {
                toast.success("Invoice Updated Successfully");

                // 3ed api call

                if (currentComponent === "invoice") {
                  let models = resultInvoice.data;
                  let payloadArray = [];

                  for (let i = 0; i < models.length; i++) {
                    const data = constructObjFromBidInvoiceTable(
                      models[i],
                      "invoice"
                    );
                    payloadArray.push(data);
                  }

                  const payload = {
                    action: "ADD",
                    InputList: payloadArray,
                  };

                  setBlocking(true);
                  let response3 = await saveQuotation(payload);
                  setBlocking(false);

                  let errorFlag = false;
                  for (let i = 0; i < response3.length; i++) {
                    if (response3[i].statusType !== "S") {
                      errorFlag = true;
                    }
                  }
                  if (errorFlag) {
                    toast.error("Error in saving data");
                  } else {
                    toast.success("Data saved successfully");

                    // 4th api call

                    let response4 = await foSubmitInvoiceMethod(tor_id);
                    if (response4.STATUS === "SUCCESS") {
                      toast.success("Invoice submitted Successful");
                      status.current = 71;
                      const allQuotations = await getAllQuotation(
                        status,
                        currentComponent,
                        tor_id,
                        tor_Type,
                        rfq_no,
                        quotationNum
                      );
                      populateDataToTable(allQuotations);
                      rePopulateInvoiceBidInputs(
                        allQuotations,
                        "on invoice submit"
                      );
                      // method in intelShipRequest.jsx
                      // logic is to make isEditClicked as false after saving or submiting
                      onEditingFinished();
                      saveInvoiceDetailInputsOnSubmit({
                        ...invoiceBidInputs,
                        childSCACData: childScacSelected,
                      });
                      hideQuotation();
                    } else {
                      toast.error("Invoice submit failed");
                    }
                  }
                }
              } else {
                toast.error(response2["message"]);
              }
            } else {
              toast.error("Invalid response");
            }
          }
        } else {
          toast.error("Invalid response");
        }
      } else if (
        submitInvoices === true &&
        (status.current === 73 || status.current === 77)
      ) {
        let response2 = await submitChargesMethod(
          tor_id,
          currencySelected,
          totalChargesInvoice
        );
        if (response2["status"] != null) {
          if (response2["status"] === "SUCCESS") {
            toast.success("Invoice Updated Successfully");

            // 3ed api call

            if (currentComponent === "invoice") {
              let models = resultInvoice.data;
              let payloadArray = [];

              for (let i = 0; i < models.length; i++) {
                const data = constructObjFromBidInvoiceTable(
                  models[i],
                  "invoice"
                );
                payloadArray.push(data);
              }
              

              const payload = {
                action: "UPD",
                InputList: payloadArray,
              };

              setBlocking(true);
              let response3 = await saveQuotation(payload);
              setBlocking(false);

              let errorFlag = false;
              for (let i = 0; i < response3.length; i++) {
                if (response3[i].statusType !== "S") {
                  errorFlag = true;
                }
              }
              if (errorFlag) {
                toast.error("Error in saving data");
              } else {
                toast.success("Data saved successfully");

                // 4th api call

                let response4 = await foSubmitInvoiceMethod(tor_id);
                if (response4.STATUS === "SUCCESS") {
                  toast.success("Invoice submitted Successful");
                  status.current = 71;
                  const allQuotations = await getAllQuotation(
                    status,
                    currentComponent,
                    tor_id,
                    tor_Type,
                    rfq_no,
                    quotationNum
                  );
                  populateDataToTable(allQuotations);
                  rePopulateInvoiceBidInputs(
                    allQuotations,
                    "on invoice submit"
                  );
                  // method in intelShipRequest.jsx
                  // logic is to make isEditClicked as false after saving or submiting
                  onEditingFinished();
                  saveInvoiceDetailInputsOnSubmit({
                    ...invoiceBidInputs,
                    childSCACData: childScacSelected,
                  });
                  hideQuotation();
                } else {
                  toast.error("Invoice submit failed");
                }
              }
            }
          } else {
            toast.error(response2["message"]);
          }
        } else {
          toast.error("Invalid response");
        }
      } else if (tor_Type == "ZEXC" && status.current === 10) {
        // For IAR Flow

        let response1 = await submitInvoiceInputs(
          invoiceBidInputs,
          childScacSelected,
          tor_id,
          tor_Type
        );
        console.log(response1)

        // 1st api call
        if (response1["STATUS"] != null) {
          if (response1["STATUS"] === "SUCCESS") {
            toast.success("HAWB/PRO Number Updated Successfully");
            setVisibleDialog(false);
            // 2nd api not called

            // 3ed api call

            if (currentComponent === "invoice") {
              let models = resultInvoice.data;
              let payloadArray = [];

              for (let i = 0; i < models.length; i++) {
                const data = constructObjFromBidInvoiceTable(
                  models[i],
                  "invoice"
                );
                payloadArray.push(data);
              }

              const payload = {
                action:
                  isEditClicked && tableDataInvoice.length > 0 ? "UPD" : "ADD",
                InputList: payloadArray,
              };

              setBlocking(true);
              let response3 = await saveQuotation(payload);
              setBlocking(false);

              let errorFlag = false;
              for (let i = 0; i < response3.length; i++) {
                if (response3[i].statusType !== "S") {
                  errorFlag = true;
                }
              }
              if (errorFlag) {
                toast.error("Error in saving data");
              } else {
                toast.success("Data saved successfully");

                const allQuotations = await getAllQuotation(
                  status,
                  currentComponent,
                  tor_id,
                  tor_Type
                );
                populateDataToTable(allQuotations);

                // method in intelShipRequest.jsx
                // Naming convention is wrong, idea here is on submit (@ buttom) clicked
                // submit (@ top) to be enabled for IAR flow
                onBidSaved();

                // method in intelShipRequest.jsx
                // logic is to make isEditClicked as false after saving or submiting
                onEditingFinished();

                rePopulateInvoiceBidInputs(allQuotations, "on invoice submit");
                saveInvoiceDetailInputsOnSubmit({
                  ...invoiceBidInputs,
                  childSCACData: childScacSelected,
                });

                // 4nd api not called
              }
            }
          } else {
            toast.error("Invalid response");
          }
        }
      }
    }
    run();
  }, [submitInvoices]);

  const autoPopulateInvoiceInputs = () => {
    setBlocking(true);

    // Doubt
    // Why only for this status 70 and 10, this should work for 71 status
    if (status.current == 70 || (tor_Type == "ZEXC" && status.current == 10)) {
      if (
        ReqPickupDate !== "Invalid Date" &&
        ReqDeliveryDate !== "Invalid Date"
      )
        setInvoiceBidInputs({
          ...invoiceBidInputs,
          actualShipmentPickupDate: new Date(ReqPickupDate),
          actualShipmentDeliveryDate: new Date(ReqDeliveryDate),
          hawbNumber:
            invoiceInputs["hawbNumber"] !== null
              ? invoiceInputs["hawbNumber"]
              : "",
          proNumber:
            invoiceInputs["proNumber"] !== null
              ? invoiceInputs["proNumber"]
              : "",
        });
    }

    // if new request or copy request
    if (isNewRequest) {
      setInvoiceBidInputs({
        ...invoiceBidInputs,
        actualShipmentPickupDate: new Date(ReqPickupDate),
        actualShipmentDeliveryDate: new Date(ReqDeliveryDate),
        hawbNumber: "",
        proNumber: "",
      });
    }
console.log(invoiceDetailInputsOnSubmit)
    // on user switch from one tab to another, data to be saved
    if (invoiceDetailInputsOnSubmit) {

      setInvoiceBidInputs({
        ...invoiceBidInputs,
        actualShipmentPickupDate: new Date(ReqPickupDate),
        actualShipmentDeliveryDate: new Date(ReqDeliveryDate),
        hawbNumber: invoiceDetailInputsOnSubmit["hawbNumber"],
        proNumber: invoiceDetailInputsOnSubmit["proNumber"],
      });
      setChildScacSelected(
        invoiceDetailInputsOnSubmit["childSCACData"]
          ? invoiceDetailInputsOnSubmit["childSCACData"]
          : { childScac: "Select SCAC" }
      );
    }

    setBlocking(false);
  };

  async function getAllQuotationPropsFunc() {
    const allQuotations = await getAllQuotation(
      status,
      currentComponent,
      tor_id,
      tor_Type
    );
    populateDataToTable(allQuotations);
  }

  function populateDataToTable({ searchRes }) {
    setBlocking(true);
    if (typeof searchRes === "undefined") {
      let _data = [];
      setTableDataBid(_data);
      setTableDataInvoice([]);
      return;
    }

    let _tableData = [];
    for (var i = 0; i < searchRes.length; i++) {
      let _data = { ...searchRes[i] };
      _data["contractedYN"] = searchRes[i]["contracted"];
      _data["quantity"] = searchRes[i]["units"];
      _data["oldQuantity"] = searchRes[i]["units"];
      _data["chargePerUnit"] = searchRes[i]["ratePerUnit"];
      _data["totalPrice"] = searchRes[i]["chargeAmount"];
      _data["currency"] = searchRes[i]["currencyCode"];

      //   need to be communicated
      setCurrencySelected({ currCode: searchRes[i]["currencyCode"] });
      currencyDropdownDisabled.current = true;

      _data["inEdit"] = false;
      _tableData.push(_data);
    }

    if (currentComponent === "bid") {
      setTableDataBid(_tableData);
      setResult(process(_tableData, dataState));
      setBlocking(false);
    } else {
      setTableDataInvoice(_tableData);
      setResultInvoice(process(_tableData, dataState));
      setBlocking(false);
    }
  }

  function rePopulateInvoiceBidInputs({ searchRes }, type) {
   
    if (status.current > 70 || (tor_Type === "ZEXC" && status.current > 10)) {
      setInvoiceBidInputs({
        ...invoiceBidInputs,
        actualShipmentPickupDate: new Date(dayjs(searchRes[0]["dateFrom"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
        actualShipmentDeliveryDate: new Date(dayjs(searchRes[0]["dateTo"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
        hawbNumber:
          invoiceInputs["hawbNumber"] !== null
            ? invoiceInputs["hawbNumber"]
            : invoiceBidInputs["hawbNumber"],
        proNumber:
          invoiceInputs["proNumber"] !== null
            ? invoiceInputs["proNumber"]
            : invoiceBidInputs["proNumber"],
      });
      if (type !== "first time api call") {
        setChildScacSelected({ ...childScacSelected });
      }
    }
    if (status.current === 45) {
      //UAT Fixes
      setInvoiceBidInputs({
        ...invoiceBidInputs,
        actualShipmentPickupDate: new Date(dayjs(searchRes[0]["dateFrom"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
        actualShipmentDeliveryDate: new Date(dayjs(searchRes[0]["dateTo"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
      });
    }
    if (status.current === 35 && buttonType === "copy Quotation") {
      setInvoiceBidInputs({
        ...invoiceBidInputs,
        actualShipmentPickupDate: new Date(dayjs(searchRes[0]["dateFrom"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
        actualShipmentDeliveryDate: new Date(dayjs(searchRes[0]["dateTo"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
      });
    }

    if (status.current === 35 && tor_Type === "ZMSB") {
      setInvoiceBidInputs({
        ...invoiceBidInputs,
        actualShipmentPickupDate: new Date(dayjs(searchRes[0]["dateFrom"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
        actualShipmentDeliveryDate: new Date(dayjs(searchRes[0]["dateTo"], 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')),
      });
    }
  }

  // Continue
  async function dialogButton1Click() {
    if (hawbProValidation) setVisibleDialog(!visibleDialog);
    if (dialogItems.current["dialogFor"] === "submitInvoiceInputs") {
      setSubmitInvoices(true);
      // Api call will be in useEffect of submitInvoice
    }

    if (dialogItems.current["dialogFor"] === "cancelInvoiceInputs") {
      var invoiceHAWBPROUpdateObj = {};
      invoiceHAWBPROUpdateObj["tor_id"] = tor_id;
      invoiceHAWBPROUpdateObj["IM_HAWBNUMBER"] = invoiceBidInputs["hawbNumber"];
      let response = await foCancel(invoiceHAWBPROUpdateObj);
      if (response.STATUS == "SUCCESS") {
        toast.success("NCRM Request has been cancelled");
        sessionStorage.setItem("tor_id", tor_id);
        // redirect to request authorized
        //  props.history.push({
        //      pathname:`/NCRMHome`
        //  });
        window.location.href = "/NCRMHome";
        //  history.pushState({

        //  })
      }
    }
  }

  // Cancel
  function dialogButton2Click() {
    setVisibleDialog(!visibleDialog);
    isSubmitDisabled.current = false;
    dialogItems.current = { ...dialogItems.current, button2: true };
  }

  async function handleSaveClick() {
    setTempDisableSaveBtnBid(true);
    let weightThresholdResponse = await getWeightThreshold();
    let weightThreshold = 0;
    if (weightThresholdResponse.STATUS == "SUCCESS") {
      weightThreshold = weightThresholdResponse.DOCNUM;
    }

    let isError = false;
    let models = currentComponent === "bid" ? result.data : resultInvoice.data;

    if (currentComponent === "invoice") {
      const errorObj = validateInvoiceFieldInputs(
        invoiceBidInputs,
        childScacSelected
      );
      if (errorObj.isError === true) {
        toast.error(errorObj.message);
        isError = true;
        isSubmitDisabled.current = false;
        return;
      }
      isSubmitDisabled.current = true;
    }

    if (currentComponent === "bid") {
      const errorObj = validateBidFieldInputs(currencySelected);
      if (errorObj.isError === true) {
        toast.error(errorObj.message);
        isError = true;
        setTempDisableSaveBtnBid(false);
        return;
      }
    }

    if (models.find((item) => item['contractedYN'] === 'N') === undefined) {
      toast.error('An NCRM should have atleast 1 Non-Contracted Fee Charge in it');
      if (currentComponent === "bid") setTempDisableSaveBtnBid(false);
      if (currentComponent === "invoice") isSubmitDisabled.current = false;
      return;
    }

    let payloadArray = [];
    for (let i = 0; i < models.length; i++) {
      // Error check is for both bid and invoice table inputs
      const errorObj = await invoiceBidTableInputValidation(
        status,
        models[i],
        currentComponent,
        weightThreshold
      );
      if (errorObj.isError === true) {
        toast.error(errorObj.message);
        isError = true;
        isSubmitDisabled.current = false;
        setTempDisableSaveBtnBid(false);
        return;
      }

      if (buttonType !== "copy Quotation") {
        if (models[i].inEdit) {
          const data = constructObjFromBidInvoiceTable(models[i], "bid");
          payloadArray.push(data);
        }
      } else {
        // If form RFQ screen copy Quotation clicked
        const data = constructObjFromBidInvoiceTable(models[i], "bid");
        payloadArray.push(data);
      }
    }

    if (payloadArray.length === 0 && isEditClicked) {
      // if the table data is added and deleted save will be enabled
      toast.error("There is nothing to be added");
      setTempDisableSaveBtnBid(false);
      return;
    }

    if (!isError) {
      if (currentComponent === "bid") {

        // for rfq accept and create action
        if (status.current === 35) {
          const data = constructObjForCreateQuotation();
          const response = await createQuotation(data);
          if (response["status"] === "SUCCESS") {
            toast.success(response["message"]);
            payloadArray = payloadArray.map((data) => ({
              ...data,
              rfqNum: rfq_no,
              quotationNum: response["docnum"],
            }));
          } else {
            toast.error(response["error"]);
            setTempDisableSaveBtnBid(false);
            return;
          }
        }

        const payload = {
          action: "ADD",
          InputList: payloadArray,
        };

        setBlocking(true);
        let response = await saveQuotation(payload);

        let errorFlag = false;
        for (let i = 0; i < response.length; i++) {
          if (response[i].statusType !== "S") {
            errorFlag = true;
          }
        }

        if (errorFlag) {
          toast.error("Error in saving data");
          setTempDisableSaveBtnBid(false);
        } else {
          if (status.current === 35) {
            hideQuotation();
            return;
          }

          const allQuotations = await getAllQuotation(
            status,
            currentComponent,
            tor_id,
            tor_Type
          );
          populateDataToTable(allQuotations);
          toast.success("Data saved successfully");
          setIsAddFeeCodeClicked(false);

          // method in intelShipRequest.jsx
          onBidSaved();

          // method in intelShipRequest.jsx
          // logic is to make isEditClicked as false after saving or submiting
          onEditingFinished();
        }

        setBlocking(false);
      }

      if (currentComponent === "invoice") {
        if (status.current == 73 || status.current == 77) {
          setSubmitInvoices(true);
        } else {
          // Validation for hawb nubmer and pro number
          const validationPayload = {
            im_hawbnumber: invoiceBidInputs["hawbNumber"],
            im_prolinenumber: invoiceBidInputs["proNumber"],
            IM_TSPEXEC_SCAC: childScacSelected["childScac"],
          };
          let response = await validateInvoiceInputs(validationPayload);

          if (response["EXIST"] === "Yes") {
            //PopUp message telling that the hawb# and Pro# exists.
            // let textContent =
            // "The HAWB# and/or PRO# already exist on a previously approved request,<br> and payment will be issued for a single request only<br> Click on Continue to proceed further.";
            let textContent = `An NCRM record for this HAWB# already exists. \n
              Click CONFIRM to close this request without submission. \n
              Click CANCEL to edit the HAWB#.`;

            dialogItems.current = {
              ...dialogItems.current,
              dialogTitle: "Error Message",
              dialogContent: textContent,
              button1Content: "Confirm",
              button2Content: "Cancel",
              dialogFor: "cancelInvoiceInputs",
            };
            setVisibleDialog(true);
            setHawbProValidation(true);
            // If continue dialogButton1Click called
          } else {
            // Submit for hawb nubmer, pro number and other inputs
            // side effect will call the api
            let textContent = `After Submit, this request CANNOT BE EDITED. \n
              Click SUBMIT if details are correct. \n 
              Click CANCEL to make changes.`;

            dialogItems.current = {
              ...dialogItems.current,
              dialogTitle: "Warning!",
              dialogContent: textContent,
              button1Content: "Submit",
              button2Content: "Cancel",
              dialogFor: "submitInvoiceInputs",
            };
            setHawbProValidation(false);
            setVisibleDialog(true);
            // setSubmitInvoices(true);
          }
        }
      }
    } else {
      setTempDisableSaveBtnBid(false);
    }

    setBlocking(false);
  }

  function constructObjForCreateQuotation() {
    return {
      rfqNum: rfq_no,
      respType: "Accepted",
      rejReason: null,
      sourceDatetime:
        dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format(
          "DD/MM/YYYY"
        ) === dayjs(ReqPickupDate).format("DD/MM/YYYY")
          ? null
          : dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format(
              "YYYYMMDD000000"
            ),
      destDatetime:
        dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
          "DD/MM/YYYY HH:mm:ss"
        ) === dayjs(ReqDeliveryDate).format("DD/MM/YYYY HH:mm:ss")
          ? null
          : dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
              "YYYYMMDD000000"
            ),
      totalPrice: totalCharges["totalQuotationCharges"].toString(),
      respCurrency: rfq_multibid_currency,
      Comments: null,
    };
  }

  function constructObjFromBidInvoiceTable(models, type) {
    if (type === "bid") {
      const data = {
        orderType: tor_Type,
        feeCodeStatus: "X",
        foNum: tor_id,
        rfqNum: rfq_no,
        quotationNum: quotationNum,
        docType: "QUOTE",
        feeCode: models.feeCode.split(" ")[0],
        contracted: models.contractedYN,
        tariffType: models.tariffType,
        units: parseFloat(models.quantity).toFixed(2),
        ratePerUnit: parseFloat(models.chargePerUnit).toFixed(2),
        chargeAmount: parseFloat(models.totalPrice).toFixed(2),
        comments: typeof models.comments === "undefined" ? "" : models.comments,
        tpt: "",
        currencyCode: currencySelected["currCode"],
        stopDateFlag: "",
        dateFrom: dayjs(ReqPickupDate).format("YYYYMMDD"),
        // dateFrom: dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format("YYYYMMDD"),
        timeFrom: dayjs(ReqPickupDate).format("HHmmss"),
        timeFromZone: timeFromZone,
        dateTo: dayjs(ReqDeliveryDate).format("YYYYMMDD"),
        //actualShipmentDeliveryDate
        // dateTo: dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format("YYYYMMDD"),

        timeTo: dayjs(ReqDeliveryDate).format("HHmmss"),
        timeToZone: timeToZone,
        createdBy: JSON.parse(sessionStorage.getItem("profile"))["USER_ID"],
        
      };
      if(tor_Type === "ZMSB" && (status.current == 45 || status.current == 35))
      {
        data["dateFrom"] = dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format(
          "YYYYMMDD"
        )
        data["dateTo"] = dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
          "YYYYMMDD"
        )
        data["timeFrom"] = dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format("HHmmss")
        data["timeTo"] = dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
          "HHmmss"
        )
      }
      return data;
    } else {
      if (status.current == 73 || status.current == 77) {
        const data = {
          orderType: tor_Type,
          feeCodeStatus: models.inEdit == true ? "A" : "X",
          foNum: tor_id,
          rfqNum: rfq_no,
          quotationNum: quotationNum,
          docType: "INVOICE",
          feeCode: models.feeCode.split(" ")[0],
          contracted: models.contractedYN,
          tariffType: models.tariffType,
          units: parseFloat(models.quantity).toFixed(2),
          ratePerUnit: parseFloat(models.chargePerUnit).toFixed(2),
          chargeAmount: parseFloat(models.totalPrice).toFixed(2),
          comments:
            typeof models.comments === "undefined" ? "" : models.comments,
          tpt: "",
          currencyCode: currencySelected["currCode"],
          stopDateFlag: "",
          // dateFrom: dayjs(ReqPickupDate).format("YYYYMMDD"),
          dateFrom: dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format(
            "YYYYMMDD"
          ),
          timeFrom: dayjs(ReqPickupDate).format("HHmmss"),
          timeFromZone: timeFromZone,
          // dateTo: dayjs(ReqDeliveryDate).format("YYYYMMDD"),
          //actualShipmentDeliveryDate
          dateTo: dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
            "YYYYMMDD"
          ),

          timeTo: dayjs(ReqDeliveryDate).format("HHmmss"),
          timeToZone: timeToZone,
          createdBy: JSON.parse(sessionStorage.getItem("profile"))["USER_ID"],
        };
//UAT fix
       
        return data;
      } else {
        const data = {
          orderType: tor_Type,
          feeCodeStatus: models.inEdit == true ? "A" : "X",
          foNum: tor_id,
          rfqNum: rfq_no,
          quotationNum: quotationNum,
          docType: "INVOICE",
          feeCode: models.feeCode.split(" ")[0],
          contracted: models.contractedYN,
          tariffType: models.tariffType,
          units: parseFloat(models.quantity).toFixed(2),
          ratePerUnit: parseFloat(models.chargePerUnit).toFixed(2),
          chargeAmount: parseFloat(models.totalPrice).toFixed(2),
          comments:
            typeof models.comments === "undefined" ? "" : models.comments,
          tpt: "",
          currencyCode: currencySelected["currCode"],
          stopDateFlag: "",
          // dateFrom: dayjs(ReqPickupDate).format("YYYYMMDD"),
          dateFrom: dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format(
            "YYYYMMDD"
          ),
          timeFrom: dayjs(ReqPickupDate).format("HHmmss"),
          timeFromZone: timeFromZone,
          // dateTo: dayjs(ReqDeliveryDate).format("YYYYMMDD"),
          //actualShipmentDeliveryDate
          dateTo: dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
            "YYYYMMDD"
          ),

          timeTo: dayjs(ReqDeliveryDate).format("HHmmss"),
          timeToZone: timeToZone,
          createdBy: JSON.parse(sessionStorage.getItem("profile"))["USER_ID"],
        };
        return data;
      }
    }
  }

  function isBidSaveBtnDisabled() {
    if (tempDisableSaveBtnBid) {
      return true;
    }
    if (isCreaedUserDifferentFromLoggedInUserAtStatus10) {
      if (userRole === 'CW') {} 
      else return true;
    }
    if (buttonType === "copy Quotation") return false;
    if (tableDataBid !== null) {
      if (tableDataBid.length && !isAddFeeCodeClicked) return true;
      return false;
    }
    return false;
  }

  function isInvoiceSubmitBtnDisabled() {
    if (isEditClicked) {
      isSubmitDisabled.current = false;
    }
    if (isSubmitDisabled.current) {
      return true;
    }
    if (isCreaedUserDifferentFromLoggedInUserAtStatus10) {
      return true;
    }
    if (tor_Type == "ZEXC" && status.current === 10) {
      // IAR flow
      if (tableDataInvoice !== null) {
        if (tableDataInvoice.length && !isEditClicked) {
          return true;
        }
      }
    }
    return false;
  }

  function invoiceBidSubmitButton() {
    if (currentComponent === "bid") {
      return status.current > 10 && status.current !== 35 ? (
        <></>
      ) : (
        <Button
          primary={true}
          onClick={handleSaveClick}
          className="btn k-button"
          disabled={isBidSaveBtnDisabled()}
        >
          Save
        </Button>
      );
    } else if (currentComponent === "invoice") {
      return status.current > 10 &&
        status.current != 70 &&
        status.current != 73 ? (
        <></>
      ) : (
        <Button
          primary={true}
          onClick={handleSaveClick}
          className="btn k-button"
          disabled={isInvoiceSubmitBtnDisabled()}
        >
          Save
        </Button>
      );
    }
  }

  function disableInvoiceInputs() {
    if (status.current >= 71) {
      return true;
    }
    if (tor_Type == "ZEXC" && status.current === 10) {
      // IAR flow
      if (tableDataInvoice !== null) {
        if (tableDataInvoice.length && !isEditClicked) {
          return true;
        }
      }
    }
    if (tor_Type == "ZEXC" && status.current > 10) {
      // IAR flow
      return true;
    }
    return false;
  }

  function isMultibidInputsDisabled() {
    if (status.current === 35) {
      return false;
    }
    return true;
  }
  console.log(invoiceBidInputs)
  console.log(invoiceInputs)


  return (
    <div className="invoicebid-details">
      <BlockUi
        tag="div"
        blocking={blocking}
        loader={
          <Circles
          color="#00BFFF"
          height="100"
          width="100"
          timeout="6000" //3 secs
        />
        }
      >
        {visibleDialog && (
          <Dialog
            title={dialogItems.current["dialogTitle"]}
            onClose={() => {
              setVisibleDialog(!visibleDialog);
            }}
          >
            <p style={{ margin: "25px", textAlign: "center",color:"black" }}>
              {dialogItems.current["dialogContent"].split("\n").map((text) => (
                <p>{text}</p>
              ))}
            </p>
            <DialogActionsBar>
              <button
                className="btn k-button k-button-icontext"
                onClick={dialogButton1Click}
              >
                {dialogItems.current["button1Content"]}
              </button>
              <button
                className="btn k-button k-button-icontext rejectbtn"
                onClick={dialogButton2Click}
              >
                {dialogItems.current["button2Content"]}
              </button>
            </DialogActionsBar>
          </Dialog>
        )}

        {/* Header for Multi bid */}
        {tor_Type === "ZMSB" && rfq_no !== "" && (
          <>
            <div class="multibid-header">
              <img
                src={backBtn}
                alt="back"
                className="bkbtn"
                onClick={() => hideQuotation()}
              />
              {currentComponent === "bid" ? (
                <span> Quotation Details </span>
              ) : (
                <span> Invoice Details </span>
              )}
              <span>RFQ Number: {rfq_no}</span>
            </div>
            {/* {status.current !== 70 &&
              status.current !== 71 &&
              status.current !== 73 &&
              status.current !== 90 && ( */}
            {currentComponent === "bid" && (
              <>
                <div className="invoice-details-inputs">
                  <div>
                    <label>
                      Proposed Shipment Pickup Date <em>*</em>
                    </label>
                    <DatePicker
                      disabled={isMultibidInputsDisabled()}
                      value={invoiceBidInputs["actualShipmentPickupDate"]}
                      onChange={(event) => {
                        setInvoiceBidInputs({
                          ...invoiceBidInputs,
                          actualShipmentPickupDate: event.target.value,
                        });
                      }}
                    />
                  </div>
                  <div>
                    <label>
                      Proposed Shipment Delivery Date <em>*</em>
                    </label>
                    <DatePicker
                      disabled={isMultibidInputsDisabled()}
                      value={invoiceBidInputs["actualShipmentDeliveryDate"]}
                      onChange={(event) => {
                        setInvoiceBidInputs({
                          ...invoiceBidInputs,
                          actualShipmentDeliveryDate: event.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {/* )} */}
          </>
        )}

        {/* <ToastContainer position="top-right" autoClose={5000} /> */}

        <div
          className={
            currentComponent === "bid"
              ? "bidDetails-dropdowns"
              : "invoice-details-inputs"
          }
        >
          {currentComponent === "invoice" && (
            <div>
              <label>
                HAWB Number<em>*</em>
              </label>
              <Input
                maxLength="15"
                disabled={disableInvoiceInputs()}
                value={invoiceBidInputs["hawbNumber"]}
                onChange={(event) => {
                  setInvoiceBidInputs({
                    ...invoiceBidInputs,
                    hawbNumber: event.target.value,
                  });
                }}
                style={{width: "35%", marginBottom: "10px"}}
              />
            </div>
          )}
          {currentComponent === "invoice" && (
            <div>
              <label>
                Pro Number <em>*</em>
              </label>
              <Input
                maxLength="15"
                disabled={disableInvoiceInputs()}
                value={invoiceBidInputs["proNumber"]}
                onChange={(event) => {
                  setInvoiceBidInputs({
                    ...invoiceBidInputs,
                    proNumber: event.target.value,
                  });
                }}
                style={{width: "35%", marginBottom: "10px"}}
              />
            </div>
          )}
          {/* For Multi bid (RFQ - accept and create quotation) 
            not to display Currency input */}
          {!(tor_Type === "ZMSB" && status.current === 35) && (
            <div>
              <label>
                Currency<em>*</em>
              </label>
              <DropDownList
                data={currencyList}
                disabled={currencyDropdownDisabled.current}
                textField="currCode"
                value={currencySelected}
                onChange={(e) => {
                  setCurrencySelected(e.value);
                }}
                style={{width: "35%", marginBottom: "10px"}}
              />
            </div>
          )}
          {currentComponent === "invoice" && (
            <div>
              <label>
                Child SCAC <em>*</em>
              </label>
              <DropDownList
                maxLength="15"
                disabled={disableInvoiceInputs()}
                data={childScacList}
                textField="childScac"
                value={childScacSelected}
                onChange={(e) => {
                  setChildScacSelected(e.value);
                }}
                style={{width: "35%", marginBottom: "10px"}}
              />
            </div>
          )}
          {currentComponent === "invoice" && (
            <div>
              <label>
                Actual Shipment Pickup Date <em>*</em>
              </label>
              <DatePicker
                disabled={disableInvoiceInputs()}
                value={invoiceBidInputs["actualShipmentPickupDate"]}
                onChange={(event) => {
                  setInvoiceBidInputs({
                    ...invoiceBidInputs,
                    actualShipmentPickupDate: event.target.value,
                  });
                }}
                style={{width: "35%", marginBottom: "10px"}}
              />
            </div>
          )}
          {currentComponent === "invoice" && (
            <div>
              <label>
                Actual Shipment Delivery Date <em>*</em>
              </label>
              <DatePicker
                disabled={disableInvoiceInputs()}
                value={invoiceBidInputs["actualShipmentDeliveryDate"]}
                onChange={(event) => {
                  setInvoiceBidInputs({
                    ...invoiceBidInputs,
                    actualShipmentDeliveryDate: event.target.value,
                  });
                }}
                style={{width: "35%", marginBottom: "10px"}}
              />
            </div>
          )}
        </div>

        {currentComponent === "bid" &&
          feeCodeData.length !== 0 &&
          unitType.length !== 0 &&
          tableDataBid !== null && (
            <>
              <InvoiceBidTable
                props={props}
                currencySelected={currencySelected}
                setBlocking={setBlocking}
                toast={toast}
                unitType={unitType}
                feeCodeData={feeCodeData}
                passThroughFeeCodeData={feeCodeDataForInvoice}
                tableData={tableDataBid}
                result={result}
                setResult={setResult}
                dataState={dataState}
                setDataState={setDataState}
                getAllQuotation={getAllQuotationPropsFunc}
                currentComponent={currentComponent}
                status={status.current}
                isEditClicked={isEditClicked}
                setIsAddFeeCodeClicked={setIsAddFeeCodeClicked}
                isCreaedUserDifferentFromLoggedInUserAtStatus10={
                  isCreaedUserDifferentFromLoggedInUserAtStatus10
                }
                tor_Type={tor_Type}
                buttonType={buttonType}
                userRole={userRole}
              />
            </>
          )}

        {currentComponent === "invoice" &&
          feeCodeData.length !== 0 &&
          unitType.length !== 0 &&
          tableDataInvoice !== null && (
            <>
              <InvoiceBidTable
                props={props}
                currencySelected={currencySelected}
                setBlocking={setBlocking}
                toast={toast}
                unitType={unitType}
                feeCodeData={feeCodeData}
                passThroughFeeCodeData={feeCodeDataForInvoice}
                tableData={tableDataInvoice}
                result={resultInvoice}
                setResult={setResultInvoice}
                dataState={dataStateInvoice}
                setDataState={setDataStateInvoice}
                getAllQuotation={getAllQuotationPropsFunc}
                currentComponent={currentComponent}
                status={status.current}
                isEditClicked={isEditClicked}
                setIsAddFeeCodeClicked={setIsAddFeeCodeClicked}
                isCreaedUserDifferentFromLoggedInUserAtStatus10={
                  isCreaedUserDifferentFromLoggedInUserAtStatus10
                }
                tor_Type={tor_Type}
                buttonType={buttonType}
                userRole={userRole}
              />
            </>
          )}

        {currentComponent === "bid" && (
          <InvoiceBidCalculation
            totalCharges={totalCharges}
            currencySelected={currencySelected}
          />
        )}

        {currentComponent === "invoice" && (
          <InvoiceBidCalculation
            totalCharges={totalChargesInvoice}
            currencySelected={currencySelected}
          />
        )}

        <div className="billdetails-buttons">{invoiceBidSubmitButton()}</div>

        {/* <pre>{JSON.stringify(isSubmitDisabled.current, null, 2)} </pre> */}

        {/* <pre>
          <div>
            <pre>{JSON.stringify(status.current, null, 2)}</pre>
          </div>
        </pre> */}
      </BlockUi>
    </div>
  );
}

export default InvoiceBidDetails;
